import CustomTooltip from '../../../components/common/tooltip';
import { ReduxSelectorProps } from '../../services/constants';
import { ComponentConfig } from '@measured/puck';
import { AxiosInstance } from 'axios';
import { IAsset } from '../../interface/apiServiceInterface';
import InstagramLogo from '../../../assets/svg/instagram';
import YoutubeLogo from '../../../assets/svg/youtube';
import LinkedInLogo from '../../../assets/svg/linkedin';
import FacebookLogo from '../../../assets/svg/facebook';
import TikTokLogo from '../../../assets/svg/tiktok';
import PinterestLogo from '../../../assets/svg/pinterest';
import TwitterLogo from '../../../assets/svg/twitter';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
} from '../../utils/helper';
import { defaultImage } from '../../../components/common/image-selector/ImageSelector';
import { imageField } from '../../../page-builder/puck/reusable-props/image';
import InputField from '../../../components/common/input-field';
import {
  MarginProps,
  marginFields,
} from '../../../page-builder/puck/reusable-props/margin';
import { gapField, GapProps } from '../../puck/reusable-props/gap';
import {
  JustifyContentField,
  JustifyContentProps,
} from '../../puck/reusable-props/justify-content';
import { paddingFields, PaddingProps } from '../../puck/reusable-props/padding';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import {
  ImageProps,
  imageProps,
} from '../../../page-builder/puck/reusable-props/image-props';

export type SocialMediaProps = MarginProps &
  ImageProps &
  JustifyContentProps &
  PaddingProps &
  GapProps & {
    socialImage: {
      imageFile: IAsset;
      isShowIcon: boolean;
      content: {
        link: string;
      };
    }[];
    // divider: boolean;
    border: IBorderValueProps;
  };
export interface ImageUploaderComponentProps extends ReduxSelectorProps {
  baseService: AxiosInstance;
}

export const SocialMediaIcon = ({
  useAppSelector,
  baseService,
}: ImageUploaderComponentProps): ComponentConfig<SocialMediaProps> => {
  return {
    label: (
      <CustomTooltip title="Social Media Icon">
        <span>Social Media Icon</span>
      </CustomTooltip>
    ) as React.ReactNode as string,

    fields: {
      socialImage: {
        type: 'array',
        label: 'Social Media Icon',
        arrayFields: {
          imageFile: { ...imageField(true, baseService).file },
          isShowIcon: {
            type: 'radio',
            label: 'Hide Icon',
            options: [
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ],
          },
          content: {
            type: 'custom',
            render: ({ value, onChange }) => {
              return (
                <>
                  <div>
                    <InputField
                      label="Hyperlink"
                      className="mt-2"
                      value={value?.link}
                      onChange={e => {
                        onChange({ ...value, link: e });
                      }}
                      placeholder="Enter Hyperlink"
                    />
                  </div>
                </>
              );
            },
          },
        },
        min: 7,
        defaultItemProps: {
          imageFile: defaultImage,
          isShowIcon: false,
          content: {
            link: '',
          },
        },
        getItemSummary: item => item?.imageFile?.fileName || 'Icon',
      },
      // divider: {
      //   type: 'radio',
      //   label: 'Divider',
      //   options: [
      //     { value: true, label: 'Yes' },
      //     { value: false, label: 'No' },
      //   ],
      // },
      ...gapField,
      ...imageProps([]),
      ...JustifyContentField,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        label: 'Border',
        render: ({ value, onChange }) => (
          <Border
            value={value}
            onChange={value => onChange({ ...value })}
            title="Border"
          />
        ),
      },
    },
    // resolveData: async ({ props }, { lastData, changed }) => {
    //   let defaultTotal: number = 0;
    //   if (changed.socialImage) {
    //     props.socialImage.forEach(icon => {
    //       if (
    //         [
    //           'Youtube',
    //           'Instagram',
    //           'LinkedIn',
    //           'Facebook',
    //           'TikTok',
    //           'Pinterest',
    //           'Twitter',
    //         ].includes(icon.imageFile.fileName)
    //       ) {
    //         defaultTotal++;
    //       }
    //     });
    //   }

    //   return {
    //     props: {
    //       socialImage:
    //         defaultTotal === 7
    //           ? props.socialImage
    //           : lastData?.props.socialImage,
    //     },
    //   };
    // },
    defaultProps: {
      // divider: false,
      justifyContent: 'justify-center',
      ...borderProps,
      gap: 'gap-4',
      image: {
        height: {
          desktop: '50',
          mobile: '50',
          tablet: '50',
        },
        maxWidth: {
          desktop: '50',
          mobile: '50',
          tablet: '50',
        },
        deviceType: 'desktop',
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      socialImage: [
        {
          imageFile: {
            imageUrl: '',
            fileName: 'Youtube',
            storeID: '',
          },
          isShowIcon: false,
          content: {
            link: '',
          },
        },
        {
          imageFile: {
            imageUrl: '',
            fileName: 'Instagram',
            storeID: '',
          },
          isShowIcon: false,
          content: {
            link: '',
          },
        },
        {
          imageFile: {
            imageUrl: '',
            fileName: 'LinkedIn',
            storeID: '',
          },
          isShowIcon: false,
          content: {
            link: '',
          },
        },
        {
          imageFile: {
            imageUrl: '',
            fileName: 'Facebook',
            storeID: '',
          },
          isShowIcon: false,
          content: {
            link: '',
          },
        },
        {
          imageFile: {
            imageUrl: '',
            fileName: 'TikTok',
            storeID: '',
          },
          isShowIcon: false,
          content: {
            link: '',
          },
        },
        {
          imageFile: {
            imageUrl: '',
            fileName: 'Pinterest',
            storeID: '',
          },
          isShowIcon: false,
          content: {
            link: '',
          },
        },
        {
          imageFile: {
            imageUrl: '',
            fileName: 'Twitter',
            storeID: '',
          },
          isShowIcon: false,
          content: {
            link: '',
          },
        },
      ],
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
    },
    render: ({
      socialImage,
      editMode,
      // divider,
      image,
      margin,
      gap,
      justifyContent,
      padding,
      border,
    }) => {
      document.querySelectorAll('div').forEach(div => {
        if (
          div.textContent &&
          (div.textContent.includes('Youtube') ||
            div.textContent.includes('Instagram') ||
            div.textContent.includes('LinkedIn') ||
            div.textContent.includes('Facebook') ||
            div.textContent.includes('TikTok') ||
            div.textContent.includes('Pinterest') ||
            div.textContent.includes('Twitter'))
        ) {
          const deleteButton = div.querySelector("button[title='Delete']");
          if (deleteButton) {
            (deleteButton as HTMLElement).style.display = 'none';
          }
        }
      });
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      const imaxwidth = isNaN(+image.maxWidth[currentDeviceType])
        ? image.maxWidth[currentDeviceType]
        : +image.maxWidth[currentDeviceType];
      const iheight = isNaN(+image.height[currentDeviceType])
        ? image.height[currentDeviceType]
        : +image.height[currentDeviceType];
      return (
        <div
          className={`flex flex-wrap items-center ${justifyContent} ${gap} ${border?.borderStyle?.[currentDeviceType]}`}
          style={{
            ...marginStyles,
            ...getPaddingStyles(padding, currentDeviceType),
            ...getBorderProps(border, currentDeviceType),
          }}>
          {socialImage.map((item, index) => {
            const url = item.imageFile.imageUrl
              ? process.env.REACT_APP_S3_BUCKET_URL + item.imageFile.imageUrl
              : '';
            const getImageContent = (fileName: string) => {
              switch (fileName) {
                case 'Instagram':
                  return (
                    <InstagramLogo
                      width={imaxwidth} // Pass width here
                      height={iheight} // Pass height here
                    />
                  );
                case 'Youtube':
                  return (
                    <YoutubeLogo
                      width={imaxwidth} // Pass width here
                      height={iheight}
                    />
                  );
                case 'LinkedIn':
                  return (
                    <LinkedInLogo
                      width={imaxwidth} // Pass width here
                      height={iheight}
                    />
                  );
                case 'Facebook':
                  return (
                    <FacebookLogo
                      width={imaxwidth} // Pass width here
                      height={iheight}
                    />
                  );
                case 'TikTok':
                  return (
                    <TikTokLogo
                      width={imaxwidth} // Pass width here
                      height={iheight}
                    />
                  );
                case 'Pinterest':
                  return (
                    <PinterestLogo
                      width={imaxwidth} // Pass width here
                      height={iheight}
                    />
                  );
                case 'Twitter':
                  return (
                    <TwitterLogo
                      width={imaxwidth} // Pass width here
                      height={iheight}
                    />
                  );
                default:
                  return (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                      }}>
                      logo
                    </div>
                  );
              }
            };
            return (
              <>
                {!item.isShowIcon && (
                  <div key={index} className={`flex  items-center`}>
                    <a
                      href={item.content.link}
                      target="_blank"
                      rel="noreferrer">
                      {item.imageFile.imageUrl ? (
                        <img
                          style={{
                            maxWidth: isNaN(+image.maxWidth[currentDeviceType])
                              ? image.maxWidth[currentDeviceType]
                              : +image.maxWidth[currentDeviceType],
                            height: isNaN(+image.height[currentDeviceType])
                              ? image.height[currentDeviceType]
                              : +image.height[currentDeviceType],
                          }}
                          src={url}
                          alt=""
                          className={`rounded-full `}
                          decoding="async"
                        />
                      ) : (
                        <div
                          className="rounded-full"
                          style={{
                            maxWidth: isNaN(+image.maxWidth[currentDeviceType])
                              ? image.maxWidth[currentDeviceType]
                              : +image.maxWidth[currentDeviceType],
                            height: isNaN(+image.height[currentDeviceType])
                              ? image.height[currentDeviceType]
                              : +image.height[currentDeviceType],
                          }}>
                          {getImageContent(item.imageFile.fileName)}
                        </div>
                      )}
                    </a>
                  </div>
                )}
              </>
            );
          })}
        </div>
      );
    },
  };
};
